module.exports = __webpack_public_path__ + "static/media/leftarrCircleBlue.f6784861.svg";